import {isArray, map} from 'lodash';
import {useMemo} from 'react';
import {useRecoilStateLoadable} from 'recoil';
import {IPageableDto} from '../../../shared/types/pageable.types';
import {deviceTypesDictQuery} from '../../../store/deviceTypes/selectors';
import {taskLocationsDictQuery} from '../../../store/taskLocations/selectors';

type DictType = Record<string, string[][] | Error | Promise<unknown>>;

function prepareDict(data: IPageableDto<{name: string; code: string}>) {
  return !isArray(data?.content) ? data?.content : map(data.content, (item) => [item.name, item.code]);
}

export const useFilterPredefined = () => {
  const [{contents: taskLocations}] = useRecoilStateLoadable(taskLocationsDictQuery);
  const [{contents: deviceTypes}] = useRecoilStateLoadable(deviceTypesDictQuery);

  console.log(deviceTypes);

  const predefined = useMemo<DictType>(
    () => ({
      deviceTypeCode: prepareDict(deviceTypes),
      taskLocationCode: prepareDict(taskLocations),
    }),
    [taskLocations.content],
  );

  return predefined;
};
